<template>
	<div class="table-appeals">
		<div v-if="isAuth">

			<div class="tile">
				<div v-show="false" class="row">
					<div class="col-sm-3">
						<p>Текущий статус: 02.06.2023 13:21:07</p>
					</div>
					<div class="col-sm-3">

					</div>
					<div class="col-sm-3">
						СМД получение данных: 02.06.2023 13:21:07
					</div>
					<div class="col-sm-3">
						СМД передача данных:
					</div>
				</div>
				<table class="table table-bordered table-condensed table-sm">
					<thead>
						<tr>
							<th class="text-center" rowspan="2">Дата</th>
							<th class="text-center" rowspan="2">Наименование ТО, ФО</th>
							<th class="text-center" colspan="6">Обращения Граждан</th>
							<th class="text-center" colspan="6">Портал ССТУ</th>
						</tr>
						<tr>
							<th>ОГ</th>
							<th>На регистрации</th>
							<th>Зарегистрировано</th>
							<th>На рассмотрении</th>
							<th>Закрыта</th>
							<th>Внимание</th>
							<th>Всего СМД</th>
							<th>Нет в СМД</th>
							<th>Отправлено</th>
							<th>Нужно обновление</th>
							<th>Для отправки</th>
							<th>Внимание</th>
						</tr>
					</thead>
					<tbody class="rows">
						<tr class="statisticsRow">
							<td>{{ start_date.toLocaleDateString() + ' - ' + end_date.toLocaleDateString() }}</td>
							<td>{{ statistics.organization_name }}</td>
							<td>{{ statistics.all }}</td>
							<td>{{ statistics.on_execution }}</td>
							<td>{{ statistics.registered }}</td>
							<td>{{ statistics.on_review }}</td>
							<td>{{ statistics.closed }}</td>
							<td class="warning">
								{{ statistics.warning }}
							</td>
							<td>{{ statistics.smd_all }}</td>
							<td class="warning">
								{{ statistics.smd_is_missing }}
							</td>
							<td>{{ statistics.smd_sent }}</td>
							<td>{{ statistics.smd_for_updating }}</td>
							<td>{{ statistics.smd_for_sending }}</td>
							<td class="warning">
								{{ statistics.smd_warning }}
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div class="conversion__form">
				<div class="panel panel-primary">
					<div class="panel-heading">
						<h3 class="panel-title">Период</h3>
					</div>
					<div class="panel-body">
						<div class="row">
							<div class="col-sm-4">
								<label for="start_date">
									Начальная дата
								</label>
								<div>
									<input type="date" class="form-control"
										:value="start_date.toISOString().substring(0, 10)"
										@change="start_date = new Date($event.target.value)">
								</div>
							</div>
							<div class="col-sm-4">
								<label for="end_date">
									Конечная дата
								</label>
								<div>
									<input type="date" class="form-control" :value="end_date.toISOString().substring(0, 10)"
										@change="end_date = new Date($event.target.value)">
								</div>
							</div>
							<div class="col-sm-4">
								<div class="col-xs-4 col-sm-2 conversion__form-btn-block">
									<button type="submit" class="btn btn-default conversion__form-btn" @click="update">
										Задать
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="panel panel-primary">
					<div class="panel-heading">
						<h3 class="panel-title">Фильтр</h3>
					</div>
					<div class="panel-body">
						<!--
						<b>Отправитель: </b>
						<span>Только регистраторы</span>
						<br>
						<b>Получатель: </b>
						Департамент образования администрации города Перми<br>
						<b>Состояние ИП, СЭД: </b>
						<span>Зарегистрировано</span><br>
						<b>Статус СМД: </b>
						<span>Отправлено</span>
						<br>
						<button type="button" name="clear" value="Очистить" class="btn blue">Очистить</button>-->
						<div><span></span></div>
						<div class="col-xs-12 col-sm-10 text-right conversion__filter">
							<a @click="openFilter = true" v-show="!openFilter" class="conversion__form-link">
								Развернуть фильтр
							</a>
							<div id="filter" class="" v-show="openFilter">
								<div class="conversion__filter-elem">
									<label for="sfilter"
										class="col-xs-12 col-sm-4 conversion__filter-label">Отправитель</label>
									<div class="col-xs-12 col-sm-8 conversion__filter-elems">
										<select v-model="filters.sender" class="conversion__filter-select">
											<option value="" disabled="">Выберите отправителя</option>
											<option value="">Все</option>
											<option value="1">Регистратор</option>
											<option value="0">Гражданин</option>
										</select>
									</div>
								</div>
								<div class="conversion__filter-elem">
									<label for="department"
										class="col-xs-12 col-sm-4 conversion__filter-label">Получатель</label>
									<div class="col-xs-12 col-sm-8 conversion__filter-elems">
										<select v-model="filters.addressee" class="conversion__filter-select">
											<option disabled="" selected="">Выберите получателя</option>
											<option value="">Любой</option>
											<option v-for="item in zones" :key="item.id" :value="item.id">{{ item.name }}
											</option>
										</select>
									</div>
								</div>
								<!--
								<div class="conversion__filter-elem">
									<label for="dfilter" class="col-xs-12 col-sm-4 conversion__filter-label">Состояние ИП,
										СЭД</label>
									<div class="col-xs-12 col-sm-8 conversion__filter-elems">
										<select name="dfilter" class="conversion__filter-select">
											<option value="" disabled="" selected="">Выберите состояние</option>
											<option value="на регистрации">На регистрации</option>
											<option value="зарегистрировано">Зарегистрировано</option>
											<option value="на рассмотрении">На рассмотрении</option>
											<option value="закрыта">Закрыта</option>
											<option value="внимание">Внимание</option>
										</select>
									</div>
								</div>
								<div class="conversion__filter-elem">
									<label for="smdfilter" class="col-xs-12 col-sm-4 conversion__filter-label">Статус
										СМД</label>
									<div class="col-xs-12 col-sm-8 conversion__filter-elems">
										<select name="smdfilter" class="conversion__filter-select">
											<option value="" disabled="" selected="">Выберите статус</option>
											<option value="NULL">Нет в СМД</option>
											<option value="Отправлено в ССТУ">Отправлено</option>
											<option value="Требуется обновление в ССТУ">Нужно обновление</option>
											<option value="Требуется отправка в ССТУ">Для отправки</option>
											<option value="WARNING">Внимание</option>
										</select>
									</div>
								</div>
							-->
								<div class="conversion__filter-elem">
									<div class="col-xs-4 col-sm-2 conversion__form-btn-block">
										<button type="submit" class="btn btn-default conversion__form-btn"
											@click="getPage()">
											Применить
										</button>
									</div>
								</div>
								<a @click="openFilter = false" v-show="openFilter"
									class="conversion__form-link conversion__form-link--rm">
									Свернуть фильтр
								</a>
							</div>
						</div>
					</div>
				</div>

				<div class="panel panel-primary">
					<div class="panel-heading">
						<h3 class="panel-title">Поиск</h3>
					</div>
					<div class="">
						<div class="">
							<div class="filter-item">
								<label class="filter-label" for="uid">
									По номеру ИП
								</label>
								<input class="filter-input" type="text" v-model="filters.uid" id="uid">
							</div>
							<div class="filter-item">
								<label class="filter-label" for="full_name">
									По ФИО
								</label>
								<input class="filter-input" type="text" v-model="filters.full_name" id="full_name">
							</div>
							<div class="filter-item">
								<label class="filter-label" for="theme">
									По теме
								</label>
								<input class="filter-input" type="text" v-model="filters.theme" id="theme">
							</div>

							<div class="col-xs-4 col-sm-2 conversion__form-btn-block">
								<button type="submit" class="btn btn-default conversion__form-btn" @click="getPage()">
									Найти
								</button>
							</div>
						</div>

						<div class="cntAppeals">
							<b>Отобрано:</b> {{ data.length }} ОГ
						</div>
					</div>
				</div>
			</div>
			<form @submit.prevent="sendToPmvd" method="post" enctype="multipart/form-data">
				<div class="send-to-pmvd">
					<div v-if="is_sent_to_pmvd" class="send-to-pmvd__message">Отправлено</div>
					<button type="submit" class="btn btn-default">Отправить</button>
				</div>
			</form>

			<PagesApp :links="meta.links" class="pages" :click="getPage" />
			<table class="table table-striped">
				<thead>
					<tr>
						<th v-for="column in columns" :key="column.id" @click="sortBy(column.id)" class="pointer">
							{{ column.name }}<span class="arrow" :class="column.sort > 0 ? 'asc' : 'dsc'">
							</span>
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="cell in filteredData" :key="cell.progress">
						<td v-for="column in columns" :key="column.id">
							{{ cell[column.id] }}
						</td>
					</tr>
				</tbody>

			</table>
			<div>{{ error }}</div>
		</div>
		<div v-else>
			Недостаточно прав для доступа к этой странице
		</div>
	</div>
</template>

<script>
import authMixin from '@/mixins/authMixin'
import PagesApp from '@/components/PagesApp.vue'
import { getConfig, requestAppeals, requestAppealsCounts, getAccessToken, refresh } from '@/auth'
import getStatus from '@/functions/getStatus'
import { getDataJson, urls } from '@/api/getData'

export default {
	mixins: [
		authMixin
	],
	components: {
		PagesApp
	},
	data() {
		let start_date = new Date();
		start_date.setDate(1)
		let end_date = new Date();

		return {
			mes: 'Hello Vue!',
			sortKey: 'date_ip',
			filterKey: '',
			filterId: '',
			columns: [
				{ id: 'date_ip', name: 'Дата ИП', sort: 1 },
				{ id: 'uid', name: 'Номер ИП' },
				{ id: 'registered_date_local', name: 'Дата СЭД' },
				{ id: 'registered_number', name: 'Номер СЭД' },
				{ id: 'zone_name', name: 'Наименование ТО, ФО' },
				{ id: 'fio', name: 'ФИО гражданина' },
				{ id: 'theme', name: 'Тема ОГ' },
				{ id: 'status_desc', name: 'Состояние ОГ' },
				{ id: 'smd_status', name: 'Статус СМД' },
				{ id: 'smd_is_assigned_string', name: 'Назначен в отправку' },
				{ id: 'smd_error', name: 'Ошибка ССТУ' },
				{ id: 'smd_id', name: 'СМД Id' },
			],
			start_date,
			end_date,
			openFilter: false,
			filters: {
				sender: '',
				addressee: '',
				uid: '',
				full_name: '',
				theme: '',

			},
			savedFilters: {},
			data: [],
			statistics: {
				all: 0,
				on_execution: 0,
				registered: 0,
				on_review: 0,
				closed: 0,
				warning: 0,
				smd_all: 0,
				smd_is_missing: 0,
				smd_sent: 0,
				smd_for_updating: 0,
				smd_for_sending: 0,
				smd_warning: 0,
			},
			error: '',
			meta: {},
			links: {},
			zones: [],
			is_sent_to_pmvd: false,
		}
	},
	created() {
		this.getPage()
		this.getCounts()

		getDataJson(urls.zones).then(x => {
			this.zones = x.data
		})
	},
	computed: {
		filteredData() {
			const sortKey = this.sortKey;
			const filterId = this.filterId;
			const filterKey = this.filterKey && this.filterKey.toLowerCase();
			const sortColumn = this.columns.find(x => x.id === sortKey)
			const order = sortColumn.sort ?? 1;
			let data = this.data;

			if (filterKey) {
				data = data.filter((row) => {
					return String(row[filterId]).toLowerCase().indexOf(filterKey) > -1
				})
			}
			if (sortKey) {
				data = data.slice().sort((a, b) => {
					a = a[sortKey]
					b = b[sortKey]
					return (a === b ? 0 : a > b ? 1 : -1) * order
				})
			}
			return data
		}
	},
	methods: {
		sortBy: function (key) {
			this.sortKey = key;
			let column = this.columns.find(x => x.id === key)
			column.sort = -(column.sort ?? 1);
		},
		filtrBy: function (id, key) {
			this.filterId = id;
			this.filterKey = key;
		},
		update: function () {
			this.getPage();
			this.getCounts();
		},
		getPage: function (url) {
			requestAppeals(url, this.start_date.toLocaleDateString(), this.end_date.toLocaleDateString(), this.filters)
				.then(x => {
					let filters = this.filters
					this.savedFilters = {...filters, start_date: this.start_date.toLocaleDateString(), end_date: this.end_date.toLocaleDateString()}
					
					let data = x.data.map(x => {
						let y = { ...x }
						y.fio = `${x.last_name ?? ''} ${x.first_name ?? ''} ${x.middle_name ?? ''}`
						y.zone_name = x.zone.name
						y.date_ip = new Date(x.date).toLocaleDateString();
						y.registered_date_local = x.registered_date ? new Date(x.registered_date).toLocaleDateString() : '';
						y.status_desc = getStatus(x?.status_type?.msed_id)
						y.smd_is_assigned_string = x.smd_is_assigned ? 'Да' : 'Нет'

						return y
					})
					this.data = data
					this.meta = x.meta
					this.links = x.links
				}).catch(error => {
					this.error = error + ''
				})
		},
		getCounts: function () {
			requestAppealsCounts(this.start_date.toLocaleDateString(), this.end_date.toLocaleDateString())
				.then(x => {
					this.statistics = x.data
				})
		},
		sendToPmvd: async function () {
			console.log('send');

			let filters = this.savedFilters
			let formData = new FormData();
			if (filters.sender != '') formData.append("filter[created_by_registrar]", filters.sender);
			if (filters.addressee != '') formData.append("filter[zone_id]", filters.addressee);
			if (filters.uid != '') formData.append("filter[uid]", filters.uid);
			if (filters.full_name != '')formData.append("filter[full_name]", filters.full_name);
			if (filters.theme != '')formData.append("filter[theme]", filters.theme);
			if (filters.start_date != '')formData.append("filter[start_date]", filters.start_date);
			if (filters.end_date != '')formData.append("filter[end_date]", filters.end_date);

			const url = getConfig().apiURL + '/registrar/appeals/pmvd-sending-job';
			const options = {
				method: 'POST',
				body: formData,
				headers: {
					'Authorization': 'Bearer ' + getAccessToken(),
				},
			};
			const res = await fetch(`${url}`, options);

			if (res.status === 201) {
				this.is_sent_to_pmvd = true;
				setTimeout(() => {
					this.is_sent_to_pmvd = false;
				}, 10000);
				return;
			}

			if (res.status === 401 || res.status === 403) {
				if (res.status === 401) {
					await refresh()
				}
				const data = await res.json();
				throw new Error(data.error);
			}

			throw new Error('Ошибка получения обращений');
		},
	}
}

</script>
<style>
.send-to-pmvd {
	display: flex;
	justify-content: end;
	align-content: center;
	column-gap: 12px;
}

.send-to-pmvd__message {
	display: flex;
	align-items: center;
}
</style>